const DEFAULT_SETTINGS = {
  /*
  fieldId: { // Same ID as supplied to <Input />
    value: '',
    defaultValue: '', // Update StepReview.jsx & relevant step(s) if you need to output
  }
  */
  /* Default Advanced Settings */
  throttleEnabled: {
    value: false
    // We want to default to true on render, but never compare the default
  },
  subscribeToAllLog: {
    value: true
    // We want to default to true on render, but never compare the default
  },
  genericS3Name: {
    value: ""
  },
  genericS3ThrottleEnabled: {
    value: void 0
  },
  pollingInterval: {
    value: 5
  },
  contentTypes: {
    value: ""
  },
  compressionType: {
    value: ""
  },
  availableContents: {
    value: "JSON Array, Text"
  },
  availableCompressionType: {
    value: "GZIP, NONE"
  },
  overrideSource: {
    value: ""
  },
  sqsMessageBatchSize: {
    value: 5
  }
};
export default DEFAULT_SETTINGS;
